import styled from "styled-components";

export const Wrapper = styled.div`
  background: #F1F3F5;
  padding: 0 5.208333333333333vw;
`;
